import { installProductionConsoleGuard } from './utils/logger';

installProductionConsoleGuard();
